import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchableDropdown from "../reusableField/searchableDropdownField";
import "./clientpage.css";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { Accounts_Data, Role_Account_Query } from "../services/userApi";
import Loading from "../reusableField/loading";

const ClientPage = () => {
  const navigate = useNavigate();

  const { data: accountsData, loading: accountsLoading } = useQuery(
    Accounts_Data,
    {
      variables: { ldmsOnly: true },
    }
  );
  const [getRoles, { data: roleData, loading: roleLoading }] =
    useLazyQuery(Role_Account_Query);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rolesLoading, setRolesLoading] = useState({});
  const [isClientEmpty, setIsClientEmpty] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState({});
  const [clientRoles, setClientRoles] = useState({});

  useEffect(() => {
    if (accountsData?.allUserAccount) {
      const accounts = accountsData.allUserAccount;

      if (accounts.length === 0) {
        setIsClientEmpty(true);
      } else {
        setIsClientEmpty(false);
      }

      const formattedClients = accounts.map((account) => ({
        id: account.id,
        name: account.name,
        image: account.mainLogoUrl || account.smallLogoUrl,
      }));

      setClients(formattedClients);
      //   const initialLoadingState = {};
      //   accounts.forEach((account) => {
      //     initialLoadingState[account.id] = true;
      //   });
      //   setRolesLoading(initialLoadingState);

      //   // Fetch roles for each account
      //   accounts.forEach((account) => {
      //     fetchAccountRoles(account.id);
      //   });
    }
  }, [accountsData]);

  const fetchAccountRoles = async (accountId) => {
    setRolesLoading((prev) => ({
      ...prev,
      [accountId]: true,
    }));

    try {
      const { data } = await getRoles({
        variables: { accountId: accountId },
      });
      if (data?.getAllJobrole) {
        const formattedRoles = data.getAllJobrole.map((role) => ({
          id: role.id,
          role_name: role.name,
        }));

        setClientRoles((prev) => ({
          ...prev,
          [accountId]: formattedRoles,
        }));
      }
    } catch (err) {
      console.error(`Error fetching roles for account ${accountId}:`, err);
      setClientRoles((prev) => ({
        ...prev,
        [accountId]: [],
      }));
    } finally {
      setRolesLoading((prev) => ({
        ...prev,
        [accountId]: false,
      }));
    }
  };

  const handleRoleChange = (clientId, roleId) => {
    setSelectedRoles((prev) => ({
      ...prev,
      [clientId]: roleId,
    }));
  };

  const handleViewProject = (clientId) => () => {
    const roleId = selectedRoles[clientId];
    console.log(`Navigating to client ${clientId} with role ${roleId}`);
    navigate("/dashboard", { state: { roleId } });
    // Navigation logic will be added when integrating API
    // navigate(`/client/${roleId}/projects`);
  };

  if (accountsLoading) return <Loading message="Loading clients..." />;
  if (error) return <div className="client-error">Error: {error}</div>;

  return (
    <>
      <div className="client-sidebar"></div>
      {isClientEmpty ? (
        <div className="client-no-clients">No clients assigned.</div>
      ) : (
        <div className="client-container-header">
          <div className="client-container">
            <div className="client-cards-grid">
              {clients.map((client) => {
                const roles = clientRoles[client.id] || [];
                const isRolesLoading = rolesLoading[client.id];

                return (
                  <div key={client.id} className="client-client-card">
                    <div className="client-client-header">
                      <div className="client-client-logo">
                        <img src={client.image} alt={client.name} />
                      </div>
                    </div>
                    <div className="client-client-content">
                      <h3 className="client-client-name" title={client.name}>
                        {client.name}
                      </h3>
                      <div
                        className="client-dropdown-container"
                        onClick={() => {
                          if (
                            !clientRoles[client.id] &&
                            !rolesLoading[client.id]
                          ) {
                            fetchAccountRoles(client.id);
                          }
                        }}
                      >
                        <SearchableDropdown
                          options={roles}
                          label="role_name"
                          id="id"
                          selectedVal={selectedRoles[client.id]}
                          handleChange={(roleId) =>
                            handleRoleChange(client.id, roleId)
                          }
                          placeholder="Select Role"
                          loading={rolesLoading[client.id]}
                        />
                      </div>
                      <button
                        className="client-view-role-btn"
                        disabled={
                          !selectedRoles[client.id] ||
                          selectedRoles[client.id] === ""
                        }
                        onClick={handleViewProject(client.id)}
                      >
                        View
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClientPage;
